import { overviewComponent } from './overview.component';
import { stateResolver } from '../../app.state';

export const overviewStateName = 'app.overview';

export const overviewState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/overview',
    name: overviewStateName,
    component: overviewComponent.name,
    resolve: { stateResolver: stateResolver(overviewStateName) },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/overview/overview.state.js